import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/apiBase";

export function useCaptcha() {
  const [challenge, setChallenge] = useState(null);
  const [answer, setAnswer] = useState("");

  const refresh = useCallback(async () => {
    setAnswer("");
    try {
      const res = await axios.get(`${API}/captcha`);
      setChallenge(res.data);
    } catch (err) {
      console.error("captcha load failed", err);
      setChallenge(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const payload = { captcha_id: challenge?.captcha_id || "", captcha_answer: answer };
  return { challenge, answer, setAnswer, refresh, payload };
}

export function MathCaptcha({ captcha, testPrefix = "captcha", className = "" }) {
  const { challenge, answer, setAnswer, refresh } = captcha;
  return (
    <div className={className} data-testid={`${testPrefix}-block`}>
      <label className="font-body text-xs text-white/40 tracking-wider uppercase mb-2 flex items-center gap-1.5">
        <ShieldCheck className="w-3.5 h-3.5 text-gold" /> Security Check
      </label>
      <div className="flex items-center gap-3">
        <span className="font-display text-base text-white/85 whitespace-nowrap" data-testid={`${testPrefix}-question`}>
          {challenge?.question || "Loading…"}
        </span>
        <Input
          data-testid={`${testPrefix}-answer`}
          inputMode="numeric"
          value={answer}
          onChange={(e) => setAnswer(e.target.value.replace(/[^0-9-]/g, ""))}
          placeholder="Answer"
          className="bg-transparent border-white/10 text-white/90 font-body text-sm placeholder:text-white/20 h-11 rounded-sm focus:border-merlot/50 w-28"
        />
        <button
          type="button"
          onClick={refresh}
          aria-label="New question"
          data-testid={`${testPrefix}-refresh`}
          className="text-white/40 hover:text-gold transition-colors duration-200"
        >
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
